import React, { ChangeEvent, MouseEvent, useState } from 'react';
import styled from 'styled-components';
import ChevronLeft from '../icons/ChevronLeft';
import ChevronRight from '../icons/ChevronRight';
import { DeviceQueries } from 'Common/src/components/styled';
import { isNaN } from 'lodash';

const AdditionalGuestsPicker = ({ additionalGuestCount, setGuestCount }: {
  additionalGuestCount: number,
  setGuestCount: (num: number) => void
}) => {

  const [inputInFocus, setInputInFocus] = useState<boolean>(false);
  const [inputValue, setInputValue] = useState<string>(additionalGuestCount.toString());

  const maxAdditionalGuestCount = 9;

  const handleIncrease = (e: MouseEvent) => {
    e.preventDefault();
    if (additionalGuestCount < maxAdditionalGuestCount) {
      const newGuestCount = additionalGuestCount + 1;
      setGuestCount(newGuestCount);
      setInputValue(newGuestCount.toString())
    }
  };

  const handleDecrease = (e: MouseEvent) => {
    e.preventDefault();
    if (additionalGuestCount > 0) {
      const newGuestCount = additionalGuestCount - 1;
      setGuestCount(newGuestCount);
      setInputValue(newGuestCount.toString())
    }
  };

  const handleChange = (event: ChangeEvent<HTMLInputElement>) => {
    const eventVal = event.target.value;
    if (eventVal.trim() === '') {
      setGuestCount(0);
      setInputValue(eventVal);
    } else {
      const val = parseInt(eventVal);
      if (!isNaN(val) && val <= maxAdditionalGuestCount && val >= 0) {
        setGuestCount(val);
        setInputValue(eventVal);
      }
    }
  }

  const handleFocus = () => {
    setInputInFocus(true);
  }

  const handleBlur = () => {
    setInputInFocus(false);
  }

  return (
    <CounterWrapper>
      <ContentContainer>
        <ChevronButton $disabled={additionalGuestCount === 0} onClick={handleDecrease}>
          <ChevronLeft/>
        </ChevronButton>
        <CountDisplay $blank={additionalGuestCount === 0 && !inputInFocus}>
          {(additionalGuestCount > 0 || inputInFocus) && '+'}
          <CountInput
            inputMode="numeric"
            maxLength={1}
            value={inputInFocus ? inputValue : additionalGuestCount === 0 ? '-' : additionalGuestCount}
            onFocus={handleFocus}
            onBlur={handleBlur}
            onChange={handleChange}/>
        </CountDisplay>
        <ChevronButton $disabled={additionalGuestCount === maxAdditionalGuestCount} onClick={handleIncrease}>
          <ChevronRight/>
        </ChevronButton>
      </ContentContainer>
    </CounterWrapper>
  );
};

const CounterWrapper = styled.div`
  display: flex;
  align-items: center;
`;

const ChevronButton = styled.button<{ $disabled?: boolean }>`
  display: flex;
  ${({ $disabled = false }) => $disabled ? 'opacity: 0.5' : 'cursor: pointer'};
  align-items: center;
  border: none;
  background: none;
  padding: 0;
`

const CountDisplay = styled.span<{ $blank: boolean }>`
  text-align: center;
  font-size: 20px;
  ${({ $blank }) => $blank && 'opacity: 0.5; width: 32px'};
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 5px;
`

const ContentContainer = styled.span`
  display: inline-flex;
  position: absolute;
  right: 10px;
  top: 35px;

  @media (${DeviceQueries.mobile}) {
    margin-top: 0;
  }
`;

const CountInput = styled.input`
  font-size: 20px;
  font-family: Poppins, sans-serif;
  border: none;
  background: none;
  text-align: center;
  width: 15px;

  &:focus {
    border: none;
    outline: none;
  }
`;

export default AdditionalGuestsPicker;
